<rt-dropdown [width]="DropdownWidth.FullWidth">
  <input #colorInput [value]="value" />
  <div class="presets">
    @for (preset of presetColors; track trackByIndex($index, preset)) {
      <div [style.background-color]="preset" (click)="setValue(preset)" class="color-item"></div>
    }
  </div>
  <!--    TBD if we need colors history -->
  <!--  <div class="row">-->
  <!--    @for (history of historyColors; track trackByIndex($index, history)) {-->
  <!--      <div-->
  <!--        [style.background-color]="history || null"-->
  <!--        (click)="history && setValue(history)"-->
  <!--        class="color-item"-->
  <!--      ></div>-->
  <!--    }-->
  <!--  </div>-->
  <rt-dropdown-item (click)="reset()"
    ><span padding-tb-small-xx>{{ 'wysiwyg.reset' | translate }}</span></rt-dropdown-item
  >
</rt-dropdown>
